import { createContext, useContext, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("swadhar_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch((err) => {
        console.error("Session restore failed:", err);
        localStorage.removeItem("swadhar_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("swadhar_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("Logout request failed:", e); }
    localStorage.removeItem("swadhar_token");
    setUser(null);
  };

  const can = (perm) => !!user?.permissions?.includes(perm);

  return <AuthContext.Provider value={{ user, loading, login, logout, can, errMsg }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
